import { Outlet } from "react-router";

const ReviewsPage = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ReviewsPage;
